<template>
  <div id="Criteria" class="layout-bidding-all">
    <v-card outlined class="mt-4"
      ><v-card-title>Criteria</v-card-title
      ><v-card-text>
        <v-data-table
          :headers="headers"
          :items="dataProjectVendorCriteria"
        ></v-data-table
      ></v-card-text>
      <v-divider></v-divider>
      <v-row class="pa-4"
        ><v-col cols="6"
          ><p class="text--primary subtitle-2">Category</p>
          <p>{{ dataProjectVendorCatSubCat.categoryName }}</p></v-col
        ><v-col cols="6"
          ><p class="text--primary subtitle-2">Sub Category</p>
          <p>{{ dataProjectVendorCatSubCat.subCategoryName }}</p></v-col
        ></v-row
      ></v-card
    >
  </div>
</template>

<script>
import { _projectservice } from "../../../services/projectservice";

export default {
  data: () => ({
    dataProjectVendorCriteria: [],
    dataProjectVendorCatSubCat: {},
    headers: [
      { text: "Criteria", value: "vendorCriteriaName" },
      { text: "Condition", value: "condition" },
      { text: "Value", value: "criteriaValue" },
      { text: "Unit", value: "vendorCriteriaUnit" },
      { text: "Criteria Type", value: "criteriaRequired" },
    ],
  }),
  created() {
    this.getProjectVendorCriteria();
  },
  methods: {
    async getProjectVendorCriteria() {
      this.dataProjectVendorCriteria = await _projectservice.GetProjectCriteria(
        this.$route.params.projectId
      );
      this.dataProjectVendorCatSubCat = this.dataProjectVendorCriteria[0];
    },
  },
};
</script>

<style lang="scss" scoped></style>
